import { render, staticRenderFns } from "./PaymentSuccess.vue?vue&type=template&id=1f80b052&scoped=true&"
import script from "./PaymentSuccess.vue?vue&type=script&lang=ts&"
export * from "./PaymentSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentSuccess.vue?vue&type=style&index=0&id=1f80b052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f80b052",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
